import { getUserToken } from "./global";

export const headers = () => {
    return {
        'Authorization': getUserToken(),
        'Content-Type': 'application/json'
    }
}